import { Driver } from './driver';
export class User {
    public id?: number;
    public name?: string;
    public email?: string;
    public email_verified_at?: Date;
    public type?: string;
    public user_code?: string;
    public api_token?: string;
    public mytransfer_id?: number;
    public mytransferprovider_id?: number;
    public currency_id?: number;
    public driver_id?: boolean;
    public user_grouper_id?: number;
    public created_at?: Date;
    public updated_at?: Date;
    public deleted_at?: Date;
    
    public driver?: Driver;

}